import type { FeatureKey } from "@/components/auth/AuthProvider";
import type { ServiceSettingsRow } from "@/hooks/useSiteSettings";

function normalizePath(value: string | null | undefined) {
  return value?.trim() || null;
}

export function resolveToolSortOrder({
  href,
  featureKey,
  serviceSettings,
}: {
  href?: string | null;
  featureKey?: FeatureKey;
  serviceSettings: ServiceSettingsRow[];
}) {
  const normalizedHref = normalizePath(href);

  if (normalizedHref) {
    const routeMatch = serviceSettings.find((row) => normalizePath(row.href) === normalizedHref);
    if (typeof routeMatch?.sort_order === "number") return routeMatch.sort_order;
  }

  if (featureKey) {
    const featureMatch = serviceSettings.find((row) => row.key === featureKey);
    if (typeof featureMatch?.sort_order === "number") return featureMatch.sort_order;
  }

  return Number.MAX_SAFE_INTEGER;
}
